export const statusColors: { [key: string]: string } = {
  Forked: "al-bg-green-100 al-text-green-800",
  Created: "al-bg-blue-100 al-text-blue-800",
};
